import RootState from 'typings/RootState'
import { DataList } from './types'
import { Event } from '../../types/event'

export const selectDataList = (state: RootState): DataList =>
  state.autoEmail.dataList

export const selectEvent = (state: RootState): Event => state.autoEmail.event
